import React from "react";

import styles from "./loader.css";

export function DataSheetLoader(props) {
  return <div className={styles.loader} />;
}
